import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const ADD_NEW_PARENT_URL = `${API_URL}/api/v1/parent/add-parent`;

export function addNewParent(payload) {
    return axiosInstance({
        url: ADD_NEW_PARENT_URL,
        method: "POST",
        data: payload
    })
}

export function getParents() {
    return axiosInstance({
        url: `${API_URL}/api/v1/parent/additional-parent`,
        method: "GET"
    })
}

export function updateParent(data) {
    return axiosInstance({
        url: `${API_URL}/api/v1/parent/update-additional-parent`,
        method: "put",
        data
    })
}

export function deleteParent(data) {
    return axiosInstance({
        url: `${API_URL}/api/v1/parent/delete-additional-parent`,
        method: "put",
        data
    })
}
